import { defineMessages } from 'react-intl';

const scope = 'dashboard.contacts';

const messages = defineMessages({
  contactAddLink: {
    id: `${scope}.ContactAddLink`,
    defaultMessage: '연락처 추가',
  },
  contactEditDialogHeading: {
    id: `${scope}.ContactEditDialog.Heading`,
    defaultMessage: '연락처 수정',
  },
  contactEditDialogLegendStudent: {
    id: `${scope}.ContactEditDialog.Legend.student`,
    defaultMessage: '학생',
  },
  contactEditDialogGroupFieldLabel: {
    id: `${scope}.ContactEditDialog.GroupField.label`,
    defaultMessage: '그룹명*',
  },
  contactEditDialogTextFieldStudentName: {
    id: `${scope}.ContactEditDialog.TextField.studentName`,
    defaultMessage: '이름*',
  },
  contactEditDialogTextFieldClazzNumber: {
    id: `${scope}.ContactEditDialog.TextField.clazzNumber`,
    defaultMessage: '학급 번호',
  },
  contactEditDialogTextFieldStudentPhoneNumber: {
    id: `${scope}.ContactEditDialog.TextField.studentPhoneNumber`,
    defaultMessage: '휴대폰 번호',
  },
  contactEditDialogTextFieldStudentEmail: {
    id: `${scope}.ContactEditDialog.TextField.stduentEmail`,
    defaultMessage: '이메일 주소',
  },
  contactEditDialogNotePrimaryGuardian: {
    id: `${scope}.ContactEditDialog.Note.primaryGuardian`,
    defaultMessage: '가정통신문은 대표 보호자에게 전송됩니다.',
  },
  contactEditDialogLegendPrimaryGuardian: {
    id: `${scope}.ContactEditDialog.Legend.primaryGuardian`,
    defaultMessage: '대표 보호자',
  },
  contactEditDialogTextFieldPrimaryGuardianName: {
    id: `${scope}.ContactEditDialog.TextField.primaryGuardianName`,
    defaultMessage: '이름*',
  },
  contactEditDialogTextFieldPrimaryGuardianRelationship: {
    id: `${scope}.ContactEditDialog.TextField.primaryGuardianRelationship`,
    defaultMessage: '관계',
  },
  contactEditDialogTextFieldPrimaryGuardianPhoneNumber: {
    id: `${scope}.ContactEditDialog.TextField.primaryGuardianPhoneNumber`,
    defaultMessage: '휴대폰 번호*',
  },
  contactEditDialogTextFieldPrimaryGuardianEmail: {
    id: `${scope}.ContactEditDialog.TextField.primaryGuardianEmail`,
    defaultMessage: '이메일 주소',
  },
  contactEditDialogDeleteButton: {
    id: `${scope}.ContactEditDialog.DeleteButton`,
    defaultMessage: '삭제',
  },
  contactEditDialogLegendSecondaryGuardian: {
    id: `${scope}.ContactEditDialog.Legend.secondaryGuardian`,
    defaultMessage: '보조 보호자',
  },
  contactEditDialogTextFieldSecondaryGuardianName: {
    id: `${scope}.ContactEditDialog.TextField.secondaryGuardianName`,
    defaultMessage: '이름*',
  },
  contactEditDialogTextFieldSecondaryGuardianRelationship: {
    id: `${scope}.ContactEditDialog.TextField.secondaryGuardianRelationship`,
    defaultMessage: '관계',
  },
  contactEditDialogTextFieldSecondaryGuardianPhoneNumber: {
    id: `${scope}.ContactEditDialog.TextField.secondaryGuardianPhoneNumber`,
    defaultMessage: '휴대폰 번호*',
  },
  contactEditDialogTextFieldSecondaryGuardianEmail: {
    id: `${scope}.ContactEditDialog.TextField.secondaryGuardianEmail`,
    defaultMessage: '이메일 주소',
  },
  contactEditDialogAddButton: {
    id: `${scope}.ContactEditDialog.AddButton`,
    defaultMessage: '보호자 추가',
  },
  contactEditDialogContactSwapButton: {
    id: `${scope}.ContactEditDialog.ContactSwapButton`,
    defaultMessage: '대표 보호자 변경',
  },
  contactEditDialogCancelButton: {
    id: `${scope}.ContactEditDialog.CancelButton`,
    defaultMessage: '취소',
  },
  contactEditDialogSaveButton: {
    id: `${scope}.ContactEditDialog.SaveButton`,
    defaultMessage: '저장',
  },
  contactExportButton: {
    id: `${scope}.ContactExportButton`,
    defaultMessage: '내보내기',
  },
  contactsHeading: {
    id: `${scope}.Contacts.Heading`,
    defaultMessage: '주소록',
  },
  contactsSearchFieldPlaceholder: {
    id: `${scope}.Contacts.SearchField.placeholder`,
    defaultMessage: '이름 검색',
  },
  contactTableHeadGroup: {
    id: `${scope}.ContactTable.head.group`,
    defaultMessage: '그룹명',
  },
  contactTableHeadClazzNumber: {
    id: `${scope}.ContactTable.head.clazzNumber`,
    defaultMessage: '번호',
  },
  contactTableHeadStudentName: {
    id: `${scope}.ContactTable.head.studentName`,
    defaultMessage: '학생 이름',
  },
  contactTableHeadStudentPhoneNumber: {
    id: `${scope}.ContactTable.head.studentPhoneNumber`,
    defaultMessage: '학생 휴대폰 번호',
  },
  contactTableHeadGuardianName: {
    id: `${scope}.ContactTable.head.guardianName`,
    defaultMessage: '보호자 이름',
  },
  contactTableHeadGuardianPhoneNumber: {
    id: `${scope}.ContactTable.head.guardianPhoneNumber`,
    defaultMessage: '보호자 휴대폰 번호',
  },
  contactsTableFallbackMessageFiltered: {
    id: `${scope}.Contacts.TableFallbackMessage.filtered`,
    defaultMessage: '해당하는 연락처가 없습니다. 필터를 다시 설정해보세요.',
  },
  contactsTableFallbackMessageNoData: {
    id: `${scope}.Contacts.TableFallbackMessage.noData`,
    defaultMessage: '등록된 연락처가 없습니다. 가정통신문을 작성하기 전에 연락처를 먼저 추가해주세요.',
  },
  deleteConfirmDialogTotal: {
    id: `${scope}.DeleteConfirmDialog.total`,
    defaultMessage: '선택한 모든 연락처를 삭제하시겠습니까?{ br }(삭제 전 내보내기를 통해 데이터를 안전하게 백업해둘 수 있습니다.)',
  },
  deleteConfirmDialogChecked: {
    id: `${scope}.DeleteConfirmDialog.checked`,
    defaultMessage: '선택한 { count }개의 연락처를 삭제하시겠습니까?{ br }(삭제 전 내보내기를 통해 데이터를 안전하게 백업해둘 수 있습니다.)',
  },
  deleteConfirmDialogCancelButton: {
    id: `${scope}.DeleteConfirmDialog.CancelButton`,
    defaultMessage: '취소',
  },
  deleteConfirmDialogDeleteButton: {
    id: `${scope}.DeleteConfirmDialog.DeleteButton`,
    defaultMessage: '삭제',
  },
  deleteConfirmDialogDeleteButtonAll: {
    id: `${scope}.DeleteConfirmDialog.DeleteButton.all`,
    defaultMessage: '전체 삭제',
  },
  deleteReconfirmDialogCancelButton: {
    id: `${scope}.DeleteReconfirmDialog.CancelButton`,
    defaultMessage: '취소',
  },
  deleteReconfirmDialogDeleteButton: {
    id: `${scope}.DeleteReconfirmDialog.DeleteButton`,
    defaultMessage: '삭제',
  },
  deleteReconfirmDialogDeleteButtonAll: {
    id: `${scope}.DeleteReconfirmDialog.DeleteButton.all`,
    defaultMessage: '전체 삭제',
  },
  deleteReconfirmDialog: {
    id: `${scope}.DeleteReconfirmDialog`,
    defaultMessage: '정말 삭제하시겠습니까?{ br }삭제한 연락처는 복구할 수 없습니다.',
  },
  groupFilterSettings: {
    id: `${scope}.GroupFilter.settings`,
    defaultMessage: '그룹 관리',
  },
  rowsPerPageFilterLabel: {
    id: `${scope}.RowsPerPageFilter.label`,
    defaultMessage: '{ num }개씩 보기',
  },
  groupSettingsDialogDialogTitle: {
    id: `${scope}.GroupSettingsDialog.DialogTitle`,
    defaultMessage: '그룹 관리',
  },
  tableToolBarDeselectButton: {
    id: `${scope}.TableToolBar.DeselectButton`,
    defaultMessage: '선택 해제',
  },
  tableToolBarSelectButton: {
    id: `${scope}.TableToolBar.SelectButton`,
    defaultMessage: '전체 선택',
  },
  tableToolBarGroupChangeButton: {
    id: `${scope}.TableToolBar.GroupChangeButton`,
    defaultMessage: '그룹 변경',
  },
  tableToolBarDeleteButton: {
    id: `${scope}.TableToolBar.DeleteButton`,
    defaultMessage: '선택 삭제',
  },
  tableToolBarSelectInfo: {
    id: `${scope}.TableToolBar.SelectInfo`,
    defaultMessage: '{ count }개 선택됨',
  },
  tableToolBarSelectInfoAll: {
    id: `${scope}.TableToolBar.SelectInfo.all`,
    defaultMessage: '전체 선택됨',
  },
});

export default messages;
